import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from "@angular/router";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import 'rxjs/add/observable/of';
import {AuthService} from "./auth.service";

@Injectable()
export class AuthGuard implements CanActivate,CanActivateChild{

  constructor( private authService : AuthService, private router : Router) {
  }

  canActivate( route : ActivatedRouteSnapshot, state : RouterStateSnapshot ) {
    var userN = localStorage.getItem('currentUser')
    var user = JSON.parse(userN)
    if(!user) {
      this.router.navigate(['/authen/signin'], {queryParams: {returnUrl: state.url}});
    }
    return !!(user)

    /*return this.authService.checkLogin().map(res=>{
      ////console.log(`auth guard status:${res}`);
      if(res.status==202){
        return true;
      }
    }).catch(()=>{
      ////console.log(`state_url:${state.url}`);
      this.router.navigate(['/authen/signin'],{ queryParams: { returnUrl: state.url }});
      return Observable.of(false);
    });*/

  }

  canActivateChild(route : ActivatedRouteSnapshot, state : RouterStateSnapshot ){
    var userN = localStorage.getItem('currentUser')
    var user = JSON.parse(userN)
    if(!user) {
      this.router.navigate(['/authen/signin'], {queryParams: {returnUrl: state.url}});
    }
    return !!(user)


    /*return this.authService.checkLogin().map(res=>{
      ////console.log(`auth guard status:${res}`);
      if(res.status==202){
        return true;
      }
    }).catch(()=>{
      this.router.navigate(['/authen/signin'],{ queryParams: { returnUrl: state.url }});
      return Observable.of(false);
    });*/
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.guard.ts